// Body preparation for POST /Test/v0.1/fetchFieldFilesAndProcess.
// When fieldFileIds is non-empty the backend ignores startDate/endDate/user,
// so only the ids are sent. An empty/null fieldFileIds is dropped so the
// date-range body goes out exactly as before.
const MAX_IDS = 1000;

export const PROCESS_INITIATION_FAILED = 'Process Initiation Failed.';

export function prepareFieldFileIdsBody(body) {
	if (!body || typeof body != 'object' || Array.isArray(body)) {
		return { ok: true, idsMode: false, body };
	}
	let { fieldFileIds, ...rest } = body;
	if (
		fieldFileIds === undefined ||
		fieldFileIds === null ||
		(Array.isArray(fieldFileIds) && fieldFileIds.length == 0)
	) {
		return { ok: true, idsMode: false, body: rest };
	}
	if (!Array.isArray(fieldFileIds)) {
		return { ok: false, message: 'fieldFileIds must be an array of strings' };
	}

	let invalidIndexes = [];
	let ids = [];
	fieldFileIds.forEach((id, index) => {
		if (typeof id != 'string') {
			invalidIndexes.push(index);
		} else if (id.trim() != '') {
			ids.push(id.trim());
		}
	});
	if (invalidIndexes.length) {
		return {
			ok: false,
			message: `fieldFileIds must contain only strings, invalid at index: ${invalidIndexes.join(
				', '
			)}`,
		};
	}
	if (ids.length == 0) {
		return {
			ok: false,
			message: 'fieldFileIds contains only blank ids',
		};
	}

	let seen = new Set();
	let duplicates = new Set();
	for (let id of ids) {
		if (seen.has(id)) {
			duplicates.add(id);
		}
		seen.add(id);
	}
	if (duplicates.size) {
		return {
			ok: false,
			message: `fieldFileIds contains duplicates: ${[...duplicates].join(', ')}`,
		};
	}
	if (ids.length > MAX_IDS) {
		return {
			ok: false,
			message: `fieldFileIds accepts at most ${MAX_IDS} ids, got ${ids.length}`,
		};
	}
	return { ok: true, idsMode: true, count: ids.length, body: { fieldFileIds: ids } };
}

export function describeFieldFileIdsResponse(data, count) {
	if (!data) {
		return { text: 'Failed to make Request', color: 'error' };
	}
	if (data.ok) {
		return {
			text: `Fetch started in the background for ${count} field file id(s). Found / not found / already ingested ids are in the server logs ([FETCH_FIELD_FILE_BY_IDS]), not shown here.`,
			color: 'success',
		};
	}
	if (data.message == PROCESS_INITIATION_FAILED) {
		return {
			text: 'A fetch is already running or field fetch is disabled',
			color: 'warning',
		};
	}
	return { text: data.message, color: 'error' };
}
